import React, { useState } from 'react';
import styled from 'styled-components';
import { adminTheme } from '../styles/adminTheme';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: ${adminTheme.colors.contentBg};
`;

const Card = styled.div`
  background: white;
  border-radius: ${adminTheme.borderRadius};
  padding: 40px;
  width: 360px;
  box-shadow: ${adminTheme.shadow};
  border: 1px solid ${adminTheme.colors.border};
`;

const Logo = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

const LogoText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${adminTheme.colors.sidebarBg};
`;

const LogoSub = styled.div`
  font-size: 12px;
  color: ${adminTheme.colors.textSecondary};
  margin-top: 4px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${adminTheme.colors.textSecondary};
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${adminTheme.colors.border};
  border-radius: 4px;
  font-size: 14px;
  color: ${adminTheme.colors.text};
  margin-top: 4px;

  &:focus {
    outline: none;
    border-color: ${adminTheme.colors.primary};
    box-shadow: 0 0 0 2px ${adminTheme.colors.primary}20;
  }
`;

const SubmitBtn = styled.button`
  padding: 10px;
  background: ${adminTheme.colors.sidebarBg};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 4px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ErrorMsg = styled.div`
  font-size: 12px;
  color: ${adminTheme.colors.danger};
  text-align: center;
`;

interface LoginPageProps {
  onLogin: (username: string, password: string) => Promise<boolean>;
  error: string | null;
}

export const LoginPage: React.FC<LoginPageProps> = ({ onLogin, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    await onLogin(username, password);
    setSubmitting(false);
  };

  return (
    <Container>
      <Card>
        <Logo>
          <LogoText>BSPL Selector</LogoText>
          <LogoSub>Admin Panel</LogoSub>
        </Logo>
        <Form onSubmit={handleSubmit}>
          <div>
            <Label>Username</Label>
            <Input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div>
            <Label>Password</Label>
            <Input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <SubmitBtn type="submit" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign In'}
          </SubmitBtn>
        </Form>
      </Card>
    </Container>
  );
};
